import { render } from "./NoticeTitle.vue?vue&type=template&id=1ce55790"
import script from "./NoticeTitle.vue?vue&type=script&lang=js"
export * from "./NoticeTitle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__